module.exports = __webpack_public_path__ + "static/media/DataIntegration.75bcace8.svg";